import { Card } from 'antd';

function ProfileContainer({ title = '', extra, children }) {
  return (
    <Card title={title} extra={extra}>
      {children}
    </Card>
  );
}

export default ProfileContainer;
